module.exports = __webpack_public_path__ + "img/mike-43.047ad208.jpg";